export class ExpertAssignments{
  ID: number;
  AssignmentType: string;
  Assignments: string;
  AssignmentDate: string;
  ExpertID: number;
}
